

























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import { IField } from '@/dealroom/fields/types/field';
import FieldSettingsContainer from '@/dealroom/fields/context-menu/components/FieldSettingsContainer.vue';
import Checkbox from '@/components/Checkbox.vue';
import OptionEditor from '@/dealroom/fields/dropdown-field/components/OptionEditor.vue';
import Dropdown from '@/components/Dropdown.vue';
import { fieldLabelMaxLength } from '@/common/database-max-values';

@Component({
  components: {
    Input,
    Button,
    FieldSettingsContainer,
    Checkbox,
    OptionEditor,
    Dropdown,
  },
  data: () => ({
    fieldLabelMaxLength,
  }),
})
export default class DropdownFieldSettings extends Vue {
  @Prop() field!: IField;
  @Prop() height: string;
  @Prop() isTemplate: boolean;

  label: string = this.fieldLabel;
  isRequired: boolean = this.fieldIsRequired;
  options: string[] = [];
  prefilledOptions: string[] = [];
  prefilledValue = '';
  noPrefillOption = '';
  isEditable: boolean = this.field.isEditable;
  currentUnsavedValue = '';

  @Watch('prefilledValue')
  watchPrefilledValue(newValue: string) {
    if (!this.prefilledOptions.includes(this.noPrefillOption)) {
      this.prefilledOptions.unshift(this.noPrefillOption);
    }
    if (newValue === this.noPrefillOption || newValue === '') {
      this.prefilledValue = '';
      this.prefilledOptions.shift();
    }
  }

  get fieldLabel(): string {
    return this.field.label || '';
  }

  get fieldIsRequired(): boolean {
    return this.field.isRequired;
  }

  get fieldEditable(): boolean {
    return this.field.isEditable || this.isTemplate;
  }

  handleIsEditable(value: boolean) {
    this.isEditable = value;
  }

  handleInput(value: string): void {
    this.label = value;
  }

  handlePrefilledInput(value: string): void {
    this.prefilledValue = value;
  }

  handleUpdate(): void {
    if (this.currentUnsavedValue) {
      this.handleAddOption(this.currentUnsavedValue);
    }
    const payload: Partial<IField> = {
      isRequired: this.isRequired,
      value: this.prefilledValue,
      label: this.label,
      options: this.options,
      isEditable: this.isEditable,
    };
    this.$emit('update', payload);
  }

  handleCheckboxChange(value: boolean): void {
    this.isRequired = value;
  }

  handleAddOption(option: string): void {
    if (this.options.includes(option)) {
      return;
    }
    this.options.push(option);
    this.prefilledOptions.push(option);
  }

  handleRemoveOption(removeOption: string): void {
    this.options = this.options.filter((option: string) => option !== removeOption);
    this.prefilledOptions = [...this.options];
    if (this.prefilledValue === removeOption) {
      this.prefilledValue = '';
    }
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.handleUpdate();
    }
  }

  handleCurrentValue(value: string) {
    this.currentUnsavedValue = value;
  }

  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
    this.noPrefillOption = this.$t('no-prefilled-value').toString();
    if (this.field.options) {
      this.options = [...this.field.options];
      this.prefilledOptions = [...this.field.options];
    }
    if (this.field.value) {
      this.prefilledValue = this.field.value;
      this.prefilledOptions = [this.noPrefillOption, ...this.prefilledOptions];
    }
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }
}
